import * as React from 'react';
import { Avatar, Button, createStyles } from '@material-ui/core';
import { GridCellProps } from '@progress/kendo-react-grid';
import { getEmpPicId, showEmployee } from '@/old/utils/helper';
import { withStyles, WithStyles } from '@material-ui/core';
import API from '@/app/api/internalAPIs';
import translate from '@/app/utils/translate';

const styles = () =>
  createStyles({
    externalSign: {
      fontSize: '10px',
      fontWeight: 'bold',
      color: '#05A4D8 !important',
      float: 'left',
    },
  });

type Props = WithStyles<typeof styles> & GridCellProps;

const KendoAvatarCell = ({ dataItem, rowType, classes }: Props) => {
  if (
    rowType === 'groupHeader' ||
    rowType === 'groupFooter' ||
    rowType !== 'data'
  ) {
    return null;
  }

  const getEmployeeImageUrl = (employeeId: number): string => {
    return API.employeeImageUrl(getEmpPicId(employeeId));
  };

  const visitEmpProfile = (id: number) => {
    showEmployee(id);
  };
  return (
    <td style={{ verticalAlign: 'top' }}>
      {!dataItem.hasAccount && (
        <span className={classes.externalSign}>{translate.t('ext')}</span>
      )}
      <Button>
        <Avatar
          src={getEmployeeImageUrl(dataItem.empId)}
          onClick={() => visitEmpProfile(dataItem.empId)}
        />
      </Button>
    </td>
  );
};

export default withStyles(styles)(KendoAvatarCell);
